module.exports = __webpack_public_path__ + "img/logo-casa.7d6ba519.png";